import { Box, CardMedia, Typography } from '@mui/material'
import React from 'react'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'

const ViewJobLink = ({ adnexioJobsUrl, jobBoardUrl }) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '6.5px',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          padding: '13.5px 16px',
          borderBottom: 1,
          borderBottomColor: 'gray-line.main',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <Box
            sx={{
              backgroundColor: 'default-background.main',
              borderRadius: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '8px',
            }}
          >
            <CardMedia
              component="img"
              src={'/adnexio-logo-icon.svg'}
              sx={{ height: '30px', width: '30px' }}
            />
          </Box>
          <Typography variant="subtitle1" sx={{ color: 'dark-text.main' }}>
            adnexio.jobs
          </Typography>
        </Box>
        <a
          href={adnexioJobsUrl}
          target="_blank"
          style={{ color: '#2666BE', textDecoration: 'underline', cursor: 'pointer' }}
        >
          View link
        </a>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          padding: '13.5px 16px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <Box
            sx={{
              backgroundColor: 'default-background.main',
              borderRadius: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '8px',
            }}
          >
            <TextSnippetIcon sx={{ color: 'alternate.main', width: '30px', height: '30px' }} />
          </Box>
          <Typography variant="subtitle1" sx={{ color: 'dark-text.main' }}>
            Your job board
          </Typography>
        </Box>
        <a
          href={jobBoardUrl}
          target="_blank"
          style={{ color: '#2666BE', textDecoration: 'underline', cursor: 'pointer' }}
        >
          View link
        </a>
      </Box>
    </Box>
  )
}

export default ViewJobLink
